<template>
  <a class="call-us" ref="callUs">
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="#FF9BBE" />
      <rect
        x="15"
        y="11"
        width="11"
        height="18"
        rx="1"
        stroke="#001965"
        stroke-width="2"
      />
      <path d="M19 26H22" stroke="#001965" stroke-width="2" />
      <path d="M15.5 14H25" stroke="#001965" stroke-width="2" />
    </svg>
    <div class="call-us__content">
      <span class="call-us__content-title">{{ d.callushelplabel }}</span>
      <p class="call-us__content-paragraph">
        {{ d.callusprefix }} <a class="tel" href="tel:{{ d.callusphonenumber }}">{{d.callusphonenumber}}</a> {{d.callussuffix}}
      </p>
    </div>
    <div class="call-us__modal-title">{{ d.callushelplabel }}</div>
    <div class="call-us__modal">
      <div class="call-us__modal__container">
        <svg class="svg-close-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M14.7886 1L1 14.7886" stroke="currentColor" stroke-width="2"></path>
                                        <path d="M1.00001 1L14.7886 14.7886" stroke="currentColor" stroke-width="2"></path>
                                    </svg>
        <span>{{ d.callushelplabel }}</span>
        <p>
          {{ d.callusprefix }} <a class="tel" href="tel:{{ d.callusphonenumber }}">{{ d.callusphonenumber }}</a> {{d.callussuffix}}
        </p>
      </div>
    </div>
  </a>
</template>

<script>

import ScrollMagic from 'scrollmagic';
import gsap from 'gsap';

export default {
  data: (instance) => {
    return {
      d: instance.store[instance.store.currentCulture].dictionary,
    };
  },
  mounted(){
    
    const controller = new ScrollMagic.Controller();
    const secondController = new ScrollMagic.Controller();
    const modal = this.$el.querySelector('.call-us__modal');
    const modalContainer = this.$el.querySelector('.call-us__modal__container');
    const mobileTitle = this.$el.querySelector('.call-us__modal-title');
    let showModal = false;
    
    //Pin icon
    new ScrollMagic.Scene({
      triggerElement: this.$el,
      triggerHook: 0.1
    })
    .setPin(this.$el)
    .addTo(controller); 

    //Show help text
    new ScrollMagic.Scene({
      triggerElement: this.$el,
      triggerHook: 'onCenter',
      reverse: true,
    }).addTo(secondController)
    .on('enter', function() {
      gsap.to(mobileTitle, { height: 40, duration: 0.1 });
      gsap.to(mobileTitle, { opacity: 1, duration: 1 });
      setTimeout(function () {
        gsap.to(mobileTitle, { opacity: 0, duration: 1 });
        gsap.to(mobileTitle, { height: 0, duration: 2 });
      }, 2000); // 2-second delay for the fade-out
    });
    
    //Activate pop-up
    const handleHelpClick = () => {
      if (!showModal){        
        modal.style.width = '70vw';
        let containerheight = modalContainer.offsetHeight;
        modal.style.height = containerheight + 'px';
        showModal = true;     
      }
      else{
        modal.style.height = 0;
        showModal = false;
      }
    };
    
    this.$el.addEventListener('click', handleHelpClick);
    this.emitter.on("culture-change", () => {
      this.d = this.store[this.store.currentCulture].dictionary;
    });
  },
};
</script>

<style lang="postcss" scoped>
.call-us {
  min-width:235px;
  min-height:155px;
  z-index: 100;
  border-radius: 16px;
  display: flex;
  gap: 10px;
  position: absolute;
  right: 20px;
  @media screen and (min-width: 1024px) {
    margin-top: 60px;
  }
  svg{
    min-width:40px;
    min-height:40px;
  }
  &__content {
    background:white;
    border-radius: 16px;
    padding: 0 10px;
    max-width: 185px;
    
    &-title {
      font-family: var(--font-it);
      color: var(--color-darkblue);
      font-size: 22px;
      line-height: 26px;
      font-weight: 500;
    }

    &-paragraph {
      font-family: var(--font-it-ex);
      font-size: 16px;
      line-height: 22px;
      font-weight: 500;
      color: #8692b6;
      margin-top: 10px;
    }
  }
  .tel {
    transition: all ease 0.3s;
  }
  &:hover .tel {
    color: black;
  }

  &__modal{
    display:none;
    &__container{
      padding: 30px 30px 30px 60px;
      text-align: right;
      svg{
        min-width: 10px;
        min-height: 10px;
        position: absolute;
        top: 10px;
        right: 10px;
      }
    }
    &-title{
      display:none;
    }
    span{
      font-size:22px;
      font-weight:500;
      margin-bottom:10px;
      display:block;
      margin-bottom:15px;
      line-height: 1.5rem;
   
    }
    p{      
      font-size:16px;      
    }
  }
  
  @media screen and (max-width: 768px) {
    min-width:40px;
    min-height:40px;
    flex-direction: row-reverse; 
    cursor: pointer;
    &__modal{
      display:block;
      background:white;
      position: absolute;
      width:0;
      height:0;
      right: 0;
      overflow: hidden;
      transition: height 0.3s ease-in-out;
       box-shadow: 0 1px 8px rgb(0 0 0 / 20%);
      &-title{
        display:block;
        position:absolute;
        opacity:0;
        right: 50px;
        width: 85px;
        height: 0;
        background: white;
        line-height: 1.2rem;
        text-align: right;
        overflow: hidden;
      }
    }

    &__content {
      max-width: 100px;
      text-align: right;
      transition: opacity 0.5s ease-in-out;
      position:absolute;
      right:45px;
      .call-us__content-title {
        display: none;
        opacity:0;
        font-size:18px;
        font-weight:500;
        transition: opacity 0.5s ease-in-out;        
        &.fadeIn{
          display: block;
          animation: fadeIn 0.5s forwards ease-in-out;         
        }
      }
      &-paragraph {
        display: none;
      }
    }

    &:hover {
      .call-us__content {
        opacity: 1;
      }
    }
  }
  
}
</style>

<style lagn="postcss">
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    /* Gradually increase opacity from 0 to 1 over the duration of the animation */
    100% {
      opacity: 1;
    }
  }
</style>
